export default __webpack_public_path__ + "static/media/SAHABAT_SAMPOERNA.1c00d9ec.png";